import { Company, CreateCompany } from '@/types/companies';
import { ListResponse } from '@/types/common';
import fetchWithAuth from './base';

export const getCompanies = async ({
  clientId,
  startingAfter,
  endingBefore,
  limit,
  search,
  filterSearchParams,
}: {
  clientId: string;
  startingAfter?: string;
  endingBefore?: string;
  limit?: number;
  search?: string;
  filterSearchParams?: URLSearchParams;
}): Promise<ListResponse<Company>> => {
  const params = new URLSearchParams(filterSearchParams || {});
  if (startingAfter) {
    params.append('starting_after', startingAfter);
  }
  if (endingBefore) {
    params.append('ending_before', endingBefore);
  }
  if (limit) {
    params.append('limit', limit.toString());
  }
  if (search) {
    params.append('search', search);
  }

  const response = await fetchWithAuth(`/api/client/${clientId}/company?${params.toString()}`, {
    method: 'GET',
  });
  return response.json();
};

export const getCompany = async (clientId: string, id: string): Promise<Company> => {
  const response = await fetchWithAuth(`/api/client/${clientId}/company/${id}`, {
    method: 'GET',
  });
  return response.json();
};

export const createCompany = async (clientId: string, data: Partial<CreateCompany>) => {
  const response = await fetchWithAuth(`/api/client/${clientId}/company`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  return response.json();
};

export const updateCompany = async (clientId: string, id: string, data: Partial<Company>) => {
  const response = await fetchWithAuth(`/api/client/${clientId}/company/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  return response.json();
};

export const getCompanyCount = async (
  clientId: string,
  search?: string,
  filterSearchParams?: URLSearchParams,
  startingAfter?: string,
  endingBefore?: string,
  limit?: number
): Promise<{ total: number; icp: number; not_icp: number }> => {
  const params = new URLSearchParams(filterSearchParams || {});
  if (search) {
    params.set('search', search);
  }
  if (startingAfter) {
    params.append('starting_after', startingAfter);
  }
  if (endingBefore) {
    params.append('ending_before', endingBefore);
  }
  if (limit) {
    params.append('limit', limit.toString());
  }
  if (search) {
    params.append('search', search);
  }
  params.delete('is_icp');

  const response = await fetchWithAuth(
    `/api/client/${clientId}/company/count?${params.toString()}`,
    {
      method: 'GET',
    }
  );
  return response.json();
};
